<button
  [id]="id"
  [type]="type"
  [name]="name"
  [disabled]="disabled"
  class="PnButton"
  [ngClass]="{
    'is-loading': loading,
    'is-disabled': disabled
  }"
>
  <span *ngIf="!loading">
    {{ label }}
  </span>

  <pn-spinner *ngIf="loading"></pn-spinner>
</button>
